module.exports = __webpack_public_path__ + "img/bg-confetti.5f95895a.png";